export function moveInArray(array, element, newIndex) {
    if (newIndex < 0 || newIndex >= array.length) {
        throw new Error('index out of bounds');
    }

    const oldIndex = array.indexOf(element);
    if (oldIndex === -1) {
        throw new Error('element is not in array');
    }

    array.splice(oldIndex, 1);
    array.splice(newIndex, 0, element);
    return array;
}

export function splitInHalf(array) {
    const middleIdx = Math.ceil(array.length / 2);
    return [array.slice(0, middleIdx), array.slice(middleIdx, array.length)];
}

export function last(array) {
    return array.length > 0 ? array[array.length - 1] : null;
}

export function mixin(Hop) {
    Hop.moveInArray = moveInArray;
}
